import { render, staticRenderFns } from "./NewCreateAulaInfantil.vue?vue&type=template&id=78c38e44&scoped=true"
import script from "./NewCreateAulaInfantil.vue?vue&type=script&lang=js"
export * from "./NewCreateAulaInfantil.vue?vue&type=script&lang=js"
import style0 from "./NewCreateAulaInfantil.vue?vue&type=style&index=0&id=78c38e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c38e44",
  null
  
)

export default component.exports